// extracted by mini-css-extract-plugin
module.exports = {"Second":"Second_Second__wmpL8"};